import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { GeoJsonService } from '../services/geo-json.service';
import * as L from 'leaflet';

@Component({
    selector: 'app-hist-dev',
    templateUrl: './hist-dev.component.html',
    styleUrls: ['./hist-dev.component.sass']
})
export class HistDevComponent implements OnInit {

    private selectedPeriod;
    private selectedBaseTemp;
    private variable;
    private unit: string;
    private baseTempName: string;

    private histBaseMaps;
    private devBaseMaps;
    private histCurrentLayer;       //geojson Layer
    private devCurrentLayer;        //geojson Layer
    private histBorderLayer;        //border of historical map
    private devBorderLayer;         //border of deviation map
    private histMap;                //Leaflet map obj
    private devMap;                 //Leaflet map obj
    private preLoaderPath: string = "http://cloud.agroclimate.org/tools/kddMonitoring/assets/images/map.gif";
    private histPreloaderLayer;     //preloader on historical map
    private devPreloaderLayer;      //preloader on deviation map
    private histLegend;
    private devLegend;
    private opacity = 1;            //initialized opacity
    private opacityHis: number = 1;
    private opacityDev: number = 1;

    private baseTemps = [
        { nameF: '82°F', nameC: '27°C', value: 27, band: 1 },
        { nameF: '86°F', nameC: '30°C', value: 30, band: 2 },
        { nameF: '90°F', nameC: '32°C', value: 32, band: 3 },
        { nameF: '93°F', nameC: '33°C', value: 33, band: 4 },
        { nameF: '97°F', nameC: '36°C', value: 36, band: 5 }
    ];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private service: GeoJsonService,
        private elementRef: ElementRef
    ) { }

    //property naming in geojson is not compatiable
    //with the leaflet requirements change
    //the property naming to leaflet format
    mapColor(feature) {
        return {
            fillColor: feature.properties['fillColor'],
            fillOpacity: feature.properties['fillOpacity'],
            weight: feature.properties['strokeWidth'],
            opacity: feature.properties['strokeOpacity'],
            color: '#757575'
        };
    }

    borderStyle(feature) {
        return {
            fillOpacity: 0,
            color: '#000000',
            weight: 1
        }
    }

    getTempFullName(value) {
        for (let base of this.baseTemps) {
            if (base.value == value) {
                return this.unit == "F" ? base.nameF : base.nameC;
            }
        }
    }

    ngAfterViewInit() {
        this.elementRef.nativeElement.querySelector('#opacitySliderHist')
            .addEventListener('input', this.setOpacityHist.bind(this));

        this.elementRef.nativeElement.querySelector('#opacitySliderDev')
            .addEventListener('input', this.setOpacityDev.bind(this));
    }

    setOpacityHist(opacityValue) {
        if(isNaN(opacityValue)) {
            opacityValue = opacityValue.target.value || opacityValue.srcElement.value;
            this.opacityHis = opacityValue * 0.01;
            this.histMap.dragging.disable();
            // this.histCurrentLayer.setStyle({opacity: (opacityValue * 0.01), fillOpacity: (opacityValue * 0.01)});
            this.histCurrentLayer.setOpacity((opacityValue * 0.01));
            this.histMap.dragging.enable();
        } else {
            this.histMap.dragging.disable();
            // this.histCurrentLayer.setStyle({opacity: (this.opacityHis), fillOpacity: (this.opacityHis)});
            this.histCurrentLayer.setOpacity(this.opacityHis);
            this.histMap.dragging.enable();
        }
    }

    setOpacityDev(opacityValue) {
        if (isNaN(opacityValue)) {
            opacityValue = opacityValue.target.value || opacityValue.srcElement.value;
            this.opacityDev = opacityValue * 0.01;
            this.devMap.dragging.disable();
            //this.devCurrentLayer.setStyle({opacity: (opacityValue * 0.01), fillOpacity: (opacityValue * 0.01)});
            this.devCurrentLayer.setOpacity((opacityValue * 0.01));
            this.devMap.dragging.enable();
        } else {
            this.devMap.dragging.disable();
            //this.devCurrentLayer.setStyle({opacity: (this.opacityDev), fillOpacity: (this.opacityDev)});
            this.devCurrentLayer.setOpacity(this.opacityDev);
            this.devMap.dragging.enable();
        }

    }

    ngOnInit() {

        this.route.params.subscribe((params) => {

            this.selectedPeriod = params['period'];
            this.selectedBaseTemp = params['base'];
            this.variable = params['var'];
            this.unit = params['unit'];
            this.baseTempName = this.getTempFullName(this.selectedBaseTemp);

            if (this.histMap == null) {
                // initialize historical map
                this.histMap = L.map('hist-map', { zoomSnap: 0.1, minZoom: 3.5 }).setView([44.8846225,-93.2203424], 4);
                //this.histBaseMaps = L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoiZG9yaXNsaXUyMTciLCJhIjoiY2oybHdydzRpMDBpZzMzdGp5ODJkamJlYiJ9.FwtouO3HW1pn5gsg7nKC5g', {
                //this.histBaseMaps = L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoibWZ1YXEiLCJhIjoiY2ptOGVpYWxmMGw5ajNrbGtlcTg0ajd3dSJ9.Hm0yOi5VEw5gePLI1mMEWw', {
                this.histBaseMaps = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYWdyb2NsaW1hdGUiLCJhIjoiY2tmd29ldndzMTFsZjJ0bjR1YW84Z2F6ZCJ9.ZQFnvmjyercHT0SZ-a_ssw', {
                    id: 'mapbox.streets'
                });
                this.histBaseMaps.addTo(this.histMap);
                //initialize deviation map
                this.devMap = L.map('dev-map', { zoomSnap: 0.1, minZoom: 3.5 }).setView([44.8846225,-93.2203424], 4);
                //this.devBaseMaps = L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoiZG9yaXNsaXUyMTciLCJhIjoiY2oybHdydzRpMDBpZzMzdGp5ODJkamJlYiJ9.FwtouO3HW1pn5gsg7nKC5g', {
                    //this.devBaseMaps = L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoibWZ1YXEiLCJhIjoiY2ptOGVpYWxmMGw5ajNrbGtlcTg0ajd3dSJ9.Hm0yOi5VEw5gePLI1mMEWw', {
                    this.devBaseMaps = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYWdyb2NsaW1hdGUiLCJhIjoiY2tmd29ldndzMTFsZjJ0bjR1YW84Z2F6ZCJ9.ZQFnvmjyercHT0SZ-a_ssw', {
                    id: 'mapbox.streets'
                });
                this.devBaseMaps.addTo(this.devMap);

                //get border layer
                // this.service.getBorderGeoJson()
                //     .subscribe(res => {
                //         this.histBorderLayer = L.geoJSON(res, { style: this.borderStyle }).addTo(this.histMap);
                //         this.devBorderLayer = L.geoJSON(res, { style: this.borderStyle }).addTo(this.devMap);
                //     });
            }
            if (this.histCurrentLayer != null) {
                this.histCurrentLayer.remove();
                this.devCurrentLayer.remove();
            }
            //config preloaders
            var histZoom = this.histMap.getZoom();
            var histFactor = Math.pow(2, histZoom - 6);   //factor to keep preloader same size when zoom value changed
            var histCenter = this.histMap.getCenter();
            this.histPreloaderLayer = L.imageOverlay(this.preLoaderPath, [[histCenter.lat - 2.5 / histFactor, histCenter.lng - 3 / histFactor], [histCenter.lat + 2.5 / histFactor, histCenter.lng + 3 / histFactor]]);
            //this.histPreloaderLayer.addTo(this.histMap);
            var devZoom = this.devMap.getZoom();
            var devFactor = Math.pow(2, devZoom - 6);   //factor to keep preloader same size when zoom value changed
            var devCenter = this.devMap.getCenter();
            this.devPreloaderLayer = L.imageOverlay(this.preLoaderPath, [[devCenter.lat - 2.5 / devFactor, devCenter.lng - 3 / devFactor], [devCenter.lat + 2.5 / devFactor, devCenter.lng + 3 / devFactor]]);
            //this.devPreloaderLayer.addTo(this.devMap);
            //get GeoJSON layers
            // this.service.getGeoJson(this.selectedPeriod, this.selectedBaseTemp, "kddHis")
            //     .subscribe(res => {
            //         this.histPreloaderLayer.remove();
            //         this.histCurrentLayer = L.geoJSON(res, { style: this.mapColor }).addTo(this.histMap);
            //         this.histBorderLayer.bringToFront();
            //         this.setOpacityHist(this.opacityHis);
            //     });
            // this.service.getGeoJson(this.selectedPeriod, this.selectedBaseTemp, "kddDev")
            //     .subscribe(res => {
            //         this.devPreloaderLayer.remove();
            //         this.devCurrentLayer = L.geoJSON(res, { style: this.mapColor }).addTo(this.devMap);
            //         this.devBorderLayer.bringToFront();
            //         this.setOpacityDev(this.opacityDev);
            //     });

            const band = this.baseTemps.find(item => item.value == this.selectedBaseTemp).band;
            this.devCurrentLayer =  L.tileLayer.wms('https://wms.agroclimate.org/wms?geoid=us&band='+band+'&period=' + this.selectedPeriod + '&date=20220102', {
              layers: 'kddDev'
            }).addTo(this.devMap);

            this.histCurrentLayer =  L.tileLayer.wms('https://wms.agroclimate.org/wms?geoid=us&band='+band+'&period=' + this.selectedPeriod + '&date=20220102', {
              layers: 'kddHis'
            }).addTo(this.histMap);

            this.generateHistLegend();
            this.generateDevLegend();
        });

    }

    generateHistLegend() {
        this.service.getLegendInfo(this.variable)
            .subscribe(res => {
                if (this.histLegend != null) {
                    this.histLegend.remove();
                }
                let keys = Object.keys(res.color_map);
                this.histLegend = new L.Control({ position: 'bottomright' });
                if (this.unit == "F") {
                    keys.forEach(key => {
                        if (keys.indexOf(key) < keys.length - 1) {
                            res.range_map[key].min = Math.round((res.range_map[key].min * 1.8) * 10) / 10;
                        }
                        res.range_map[key]
                    });
                }

                this.histLegend.onAdd = function () {
                    this.div = L.DomUtil.create('div', 'info mapLegendHist');
                    this.update();
                    return this.div;
                };
                this.histLegend.update = this.unit == "F" ? function () {
                    let html = '<div style="background-color: rgba(255,255,255,0.8); height: 500px; padding: 10px; border-radius: 5px; -webkit-print-color-adjust: exact;">';
                    html += '<i style="font-weight: bold;margin-left: 15px;">°F</i><br>';
                    html += '<div><div style="float:left; width:20px; height:10px"></div>';
                    html += '<div style="float:left; width:20px; height:10px; margin-left:5px; padding-top:3px;">More</div></div>';
                    keys.forEach(key => {
                        html += '<div>';
                        html += '<div style="float:left; background-color:' + res.color_map[key] + '; width:20px; height:20px"></div>';
                        html += '<div style="float:left; width:20px; height:20px; margin-left:5px; padding-top:14px;">';
                        if (keys.indexOf(key) < keys.length - 1) {
                            html += res.range_map[key].min;
                        } else if (keys.indexOf(key) == keys.length - 1) {
                            html += '0';
                        }
                        html += '</div></div>';
                    });
                    html += '</div>';
                    this.div.innerHTML = html;
                } : function () {
                    let html = '<div style="background-color: rgba(255,255,255,0.8); height: 500px; padding: 10px; border-radius: 5px; -webkit-print-color-adjust: exact;">';
                    html += '<i style="font-weight: bold;margin-left: 15px">°C</i><br>';
                    html += '<div><div style="float:left; width:20px; height:10px"></div>';
                    html += '<div style="float:left; width:20px; height:10px; margin-left:5px; padding-top:3px;">More</div></div>';
                    keys.forEach(key => {
                        html += '<div>';
                        html += '<div style="float:left; background-color:' + res.color_map[key] + '; width:20px; height:20px"></div>';
                        html += '<div style="float:left; width:20px; height:20px; margin-left:5px; padding-top:14px;">';
                        if (keys.indexOf(key) < keys.length - 1) {
                            html += res.range_map[key].min;
                        } else if (keys.indexOf(key) == keys.length - 1) {
                            html += '0';
                        }
                        html += '</div></div>';
                    });
                    html += '</div>';
                    this.div.innerHTML = html;
                }
                this.histLegend.addTo(this.histMap);
            });
    }

    generateDevLegend() {
        this.service.getLegendInfo(this.variable + "Dev")
            .subscribe(res => {
                if (this.devLegend != null) {
                    this.devLegend.remove();
                }
                let keys = Object.keys(res.color_map);
                this.devLegend = new L.Control({ position: 'bottomright' });

                this.devLegend.onAdd = function () {
                    this.div = L.DomUtil.create('div', 'info mapLegendDev');
                    this.update();
                    return this.div;
                };
                this.devLegend.update = function () {
                    let html = '<div style="background-color: rgba(255,255,255,0.8); height: 500px; padding: 10px; border-radius: 5px; -webkit-print-color-adjust: exact;">';
                    html += '<i style="font-weight: bold;margin-left: 15px;"></i><br>';
                    html += '<div><div style="float:left; width:20px; height:10px"></div>';
                    html += '<div style="float:left; width:20px; height:10px; margin-left:5px; padding-top:3px;">More</div></div>';
                    keys.forEach(key => {
                        html += '<div>';
                        html += '<div style="float:left; background-color:' + res.color_map[key] + '; width:20px; height:20px"></div>';
                        html += '<div style="float:left; width:20px; height:20px; margin-left:5px; padding-top:14px;">';
                        if (keys.indexOf(key) < keys.length - 1) {
                            html += res.range_map[key].min;
                        } else if (keys.indexOf(key) == keys.length - 1) {
                            html += 'Less';
                        }
                        html += '</div></div>';
                    });
                    html += '</div>';
                    this.div.innerHTML = html;
                }
                this.devLegend.addTo(this.devMap);
            });
    }

}




// WEBPACK FOOTER //
// ./src/app/hist-dev/hist-dev.component.ts